import {TabsProps} from "antd";
import {Tabs} from "components/common";
import React, {useEffect, useState} from "react";
import {tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";

import {setSiderKey} from "redux/reducer/common";
import PhauThuat from "./PhauThuat";
import KhamMat from "./KhamMat";
import TuVan from "./TuVan";
import GioiTinh from "./GioiTinh";
import ChatLuong from "./ChatLuong";
import Kinh from "./Kinh";
import Marketing from "./Marketing";
import TheKham from "./TheKham";
const CombineReport: React.FC = () => {
  document.title = "Báo cáo tổng hợp";
  const id = useAppSelector(e => e.pending?.id);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setSiderKey("baoCaoTongHop"));
  }, []);

  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.COMBINE_REPORT.PHAU_THUAT_REPORT,
      label: "Phẫu thuật, thủ thuật",
      children: <PhauThuat />,
    },
    {
      key: tabKeys.COMBINE_REPORT.KHAM_MAT_REPORT,
      label: "Khám mắt",
      children: <KhamMat />,
    },
    {
      key: tabKeys.COMBINE_REPORT.TU_VAN_REPORT,
      label: "Tư vấn",
      children: <TuVan />,
    },
    {
      key: tabKeys.COMBINE_REPORT.CHAT_LUONG_REPORT,
      label: "Chất lượng",
      children: <ChatLuong />,
    },
    {
      key: tabKeys.COMBINE_REPORT.KINH_REPORT,
      label: "Kính",
      children: <Kinh />,
    },

    {
      key: tabKeys.COMBINE_REPORT.GIOI_TINH_REPORT,
      label: "Giới tính",
      children: <GioiTinh />,
    },
    // {
    //   key: tabKeys.COMBINE_REPORT.MARKKETING_REPORT,
    //   label: "Marketing",
    //   children: <Marketing />,
    // },
    // {
    //   key: tabKeys.COMBINE_REPORT.THEKHAM_REPORT,
    //   label: "Thẻ khám",
    //   children: <TheKham />,
    // },
  ];
  return (
    <div className="revenues page">
      <div className="main">
        <Tabs activeKey={activeTab} items={itemsInit} />
      </div>
    </div>
  );
};

export default CombineReport;
